(() => {
  /** @param {Element} sourceRoot */
  const parseRating = (sourceRoot) => {
    const selectors = [
      '[itemprop="ratingValue"]',
      '.yotpo-stars .sr-only',
      '.yotpo-review-stars .sr-only',
      '.yotpo-review-stars',
    ];

    for (const selector of selectors) {
      const node = sourceRoot.querySelector(selector);
      if (!node) continue;

      const text = (node.getAttribute('content') || node.textContent || '').trim();
      const match = text.match(/([1-5](?:\.\d)?)/);
      const value = match && match[1] ? parseFloat(match[1]) : Number.NaN;

      if (!Number.isNaN(value)) {
        return Math.max(1, Math.min(5, Math.round(value)));
      }
    }

    const iconCount = sourceRoot.querySelectorAll('.yotpo-icon-star, .sr-star').length;
    if (iconCount > 0) {
      return Math.max(1, Math.min(5, iconCount));
    }

    return null;
  };

  /** @param {Element} sourceRoot */
  const extractReviewData = (sourceRoot) => {
    const textNode = sourceRoot.querySelector(
      '[itemprop="description"], .content-review, .yotpo-review-content'
    );
    const authorNode = sourceRoot.querySelector(
      '[itemprop="author"], .yotpo-user-name, .yotpo-header-element .y-label'
    );
    const imageNode = sourceRoot.querySelector(
      '.yotpo-user-photo img, .yotpo-review-user img, .yotpo-review-images img'
    );
    // Yotpo truncates reviews and appends a "Read more" link — strip it from textContent
    let text = '';
    if (textNode) {
      text = textNode.getAttribute('content') || textNode.textContent.trim();
      text = text.replace(/\s*\.{3}\s*Read more\s*$/i, '').trim();
      text = text.replace(/\s*Read more\s*$/i, '').trim();
    }

    return {
      text,
      author: authorNode ? authorNode.textContent.trim() : '',
      image: imageNode ? imageNode.getAttribute('src') || '' : '',
      rating: parseRating(sourceRoot),
    };
  };

  /**
   * @param {Element|null} starsContainer
   * @param {number|null} rating
   */
  const applyStars = (starsContainer, rating) => {
    if (!starsContainer || !rating) return;

    starsContainer.setAttribute('data-rating', String(rating));

    starsContainer.querySelectorAll('.review-star').forEach(/** @param {Element} star @param {number} index */ (star, index) => {
      star.classList.toggle('review-star-inactive', index + 1 > rating);
    });
  };

  /** @param {Element} section */
  const hydrateSection = (section) => {
    const source = section.querySelector('.science-spotlight__yotpo-source');
    if (!source) return;

    const textTarget = section.querySelector('[data-review-text]');
    const authorTarget = section.querySelector('[data-review-author]');
    const imageTarget = section.querySelector('[data-review-image]');
    const starsTarget = section.querySelector('[data-review-stars]');

    const MAX_CHARS = 160;

    /** @param {string} fullText @param {boolean} expanded */
    const renderText = (fullText, expanded) => {
      if (!textTarget) return;
      const needsTruncate = fullText.length > MAX_CHARS;

      textTarget.textContent = '';

      if (!needsTruncate) {
        textTarget.textContent = fullText;
        return;
      }

      if (expanded) {
        textTarget.appendChild(document.createTextNode(fullText + ' '));
      } else {
        textTarget.appendChild(document.createTextNode(fullText.slice(0, MAX_CHARS).trimEnd() + '… '));
      }

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'science-spotlight__read-more dfk-text-body-sm';
      btn.textContent = expanded ? 'Read less' : 'Read more';
      btn.setAttribute('aria-expanded', String(expanded));
      btn.addEventListener('click', () => renderText(fullText, !expanded), { once: true });
      textTarget.appendChild(btn);
    };

    const sync = () => {
      const data = extractReviewData(source);

      if (data.text && textTarget) {
        renderText(data.text, false);
      }

      if (data.author && authorTarget) {
        authorTarget.textContent = data.author;
      }

      if (data.image && imageTarget && imageTarget.tagName === 'IMG') {
        imageTarget.setAttribute('src', data.image);
      }

      if (data.rating) {
        applyStars(starsTarget, data.rating);
      }
    };

    const observer = new MutationObserver(sync);
    observer.observe(source, { childList: true, subtree: true, characterData: true });

    // Intento inicial en caso de que Yotpo ya haya rendereado
    sync();
  };

  document.querySelectorAll('.science-spotlight').forEach(hydrateSection);
})();
